<div class="app">
    <app-hcp *ngIf="hcpModalIsShowing"></app-hcp>
    <router-outlet></router-outlet>
</div>
